import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const SET_NETWORK_PHOTO = "setNetworkPhoto";

export const navBarKeys = createKeys(featureKeys.NAVBAR, {
  setNetworkPhoto: () => [SET_NETWORK_PHOTO],
});
